import * as loadingState from '@/constants/loadingState'

import { createVoucher as apiCreateVoucher } from '../apis'

export const types = {
  CREATE_VOUCHER: 'CREATE_VOUCHER',
  CREATE_VOUCHER_SUCCESS: 'CREATE_VOUCHER_SUCCESS',
  CREATE_VOUCHER_FAILED: 'CREATE_VOUCHER_FAILED'
}

const INIT_DATA = {
  loadingState: loadingState.EMPTY,
  error: null
}

const state = _.cloneDeep(INIT_DATA)

const getters = {
  createVoucherLoadingState: state => state.loadingState
}

const mutations = {
  [types.CREATE_VOUCHER] (state) {
    state.loadingState = loadingState.LOADING
  },

  [types.CREATE_VOUCHER_SUCCESS] (state, payload) {
    state.loadingState = loadingState.READY
  },

  [types.CREATE_VOUCHER_FAILED] (state, error) {
    // 初始化資料
    Object.assign(state, _.cloneDeep(INIT_DATA))

    state.loadingState = loadingState.ERROR
    state.error = error
    console.error(error)
  }
}

const actions = {
  createVoucher ({ commit }, { storeName, postData }) {
    commit(types.CREATE_VOUCHER)

    return apiCreateVoucher(storeName, postData)
      .then(response => commit(types.CREATE_VOUCHER_SUCCESS, response))
      .catch(err => {
        commit(types.CREATE_VOUCHER_FAILED, err)
        throw err
      })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
